import { usePermanent } from "@suse-o11y/use-permanent";
import Konva from "konva";
import React from "react";

import { Container, type ContainerConfig } from "./Container";

export type LayerProps = ContainerConfig;

export const Layer: React.FC<React.PropsWithChildren<LayerProps>> = ({ children, ...config }) => {
	const layer = usePermanent(() => new Konva.Layer(config));

	return (
		<Container instance={layer} {...config}>
			{children}
		</Container>
	);
};
